const units = Object.freeze({
	1: 'uv',
	2: 'uv',
	3: 'uv',
	4: 'uv',
	5: 'uv',
	6: 'uv',
	7: 'uv',
	8: 'uv',
	9: 'uv',
	10: 'mv',
	11: 'mv',
	12: 'cmH2O',
	13: 'uv',
	14: 'uv',
	15: 'uv',
	16: '%',
	17: 'uv',
	18: 'uv',
	19: 'bpm',
	20: ''
})

export default units